export default __webpack_public_path__ + "static/media/services5.555f86f8.jpg";